import React from "react";
import cx from "classnames";
function Footer({ className }) {
    return (<footer className={cx("footer", className)} data-testid="footer">
    </footer>);
}
export default Footer;
